<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ modalTitle }}
      </p>
      <button @click="closeModal" type="button" class="close-icon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>
    <section class="modal-card-body padding-bottom82">
      <p v-html="modalContent"></p>
    </section>
    <footer class="modal-card-foot">
      <button
        class="button is-primary btn-site-properties bg-white color-black"
        @click="confirmDelete()"
      >
        {{ confirmButtonText }}
      </button>

      <button
        class="button is-primary is-rounded btn-site-properties"
        @click="closeModal"
      >
        Cancel
      </button>
    </footer>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { cloneDeep as _cloneDeep } from 'lodash';

@Component({ components: {} })
export default class DeleteModalBox extends Vue {
  @Prop()
  public modalTitle!: string;
  @Prop()
  public modalContent!: string;
  @Prop({ default: 'Delete' })
  public confirmButtonText!: string;

  @Prop()
  public id!: number;

  @Prop()
  public name!: string;
  public confirmDelete() {
    this.$emit('confirm');
    this.$emit('close');
  }
  public closeModal() {
    this.$emit('close');
  }
}
</script>
<style module></style>
